module.exports = __webpack_public_path__ + "static/index/img/baikal-903.ba4161f1.jpg";